import { ClassAttributes, createElement } from 'react';

import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';
import Screen from '../screen/FatalErrorScreen';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const FatalErrorScreen = ({ className }: Props) => (
  <DependencyConsumer>
    {(dependency) => (
      <HistoryConsumer>
        {(history) => (
          <StateConsumer>
            {(state) =>
              state.fatalError ? (
                <Screen
                  error={state.fatalError.error}
                  solveTo={state.fatalError.solveTo}
                  onClickBackButton={(_: any, solveTo: string) => {
                    history.push(solveTo);
                    location.reload();
                  }}
                  onClickInquiryButton={() => dependency.errorUsecase.requestContact()}
                  className={className}
                  pathname={state.location.pathname}
                />
              ) : null
            }
          </StateConsumer>
        )}
      </HistoryConsumer>
    )}
  </DependencyConsumer>
);

export default FatalErrorScreen;
